import React, { useState } from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { Select } from 'packages/common-frontend/components/Select';

export const mapFieldType = (
  field: string,
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[],
): 'number' | 'string' | 'boolean' => {
  const fieldWithType = availableFields.find(
    (f) => f.fullyQualifiedFieldName === field,
  );
  finleyAssert(fieldWithType, `getFieldType: [field:${field} not found`);

  const unSupportedTypes = [
    'date',
    'optionalDate',
    'dateTime',
    'optionalDateTime',
    'currency',
    'percentage',
    'optionalCurrency',
    'optionalPercentage',
  ];

  const { fieldType } = fieldWithType;
  finleyAssert(
    !unSupportedTypes.includes(fieldType),
    `getFieldType: unsupported type:${fieldWithType.fieldType}`,
  );
  switch (fieldType) {
    case 'integer':
    case 'optionalInteger':
    case 'float':
    case 'optionalFloat':
      return 'number';

    case 'string':
    case 'optionalString':
      return 'string';

    case 'boolean':
    case 'optionalBoolean':
      return 'boolean';

    case 'date':
    case 'optionalDate':
    case 'dateTime':
    case 'optionalDateTime':
    case 'currency':
    case 'percentage':
    case 'optionalCurrency':
    case 'optionalPercentage':
    default:
      // cant assert here, because JSON editor allows it.
      return 'string';
  }
};

// allows to select a field from the available fields
// shows current field, and allows to change it
// @duel_cc:todo use <SearchSelect />
type FieldSelectorProps = {
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
  allowedTypes: string[];
  initialField?: string;
  onSelectedFieldChange: (field: string) => void;
};
export const FieldSelector = ({
  availableFields,
  allowedTypes,
  initialField,
  onSelectedFieldChange,
}: FieldSelectorProps) => {
  const filteredFields = availableFields
    .filter((field) => allowedTypes.includes(field.fieldType))
    .map((field) => field.fullyQualifiedFieldName);

  const selectOptions = filteredFields.map((field) => ({
    label: field,
    value: field,
  }));

  const effectiveInitialField = initialField || selectOptions[0].value;
  const [selectedField, setSelectedField] = useState<string>(
    effectiveInitialField,
  );

  return (
    <>
      <Select<string>
        value={selectedField}
        onChange={(val) => {
          if (val) {
            setSelectedField(val);
            if (filteredFields.includes(val)) {
              onSelectedFieldChange(val);
            }
          }
        }}
        options={selectOptions}
      />
    </>
  );
};
